import React from "react";
import MediaContext from "app/app/mediaSelector/contexts/MediaContext";

export default function useMediaContext() {
    return React.useContext(MediaContext);
}
